var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',_vm._g(_vm._b({class:['text-none', { 'slide': _setup.props.animation }],attrs:{"color":"primary","block":_vm.block,"ripple":false,"outlined":"","tile":""}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_c('div',{staticClass:"inner"},[_vm._t("default")],2)])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }